export const DEVIN_GITHUB_ID = '158243242';
export const DEVIN_LOGIN = 'devin-ai-integration[bot]';
export const DEVIN_AVATAR = 'https://avatars.githubusercontent.com/in/811515?v=4';

export const COPILOT_AGENT_ID = '198982749';
export const COPILOT_AGENT_LOGIN = 'Copilot';
export const COPILOT_AGENT_AVATAR = 'https://avatars.githubusercontent.com/in/1143301?v=4';

export const CODEGEN_GITHUB_ID = '131295404';
export const CODEGEN_LOGIN = 'codegen-sh[bot]';
export const CODEGEN_AVATAR = 'https://avatars.githubusercontent.com/in/321279?v=4';

export const FACTORY_DROID_GITHUB_ID = '138933559';
export const FACTORY_DROID_LOGIN = 'factory-droid[bot]';
export const FACTORY_DROID_AVATAR = 'https://avatars.githubusercontent.com/in/358017?v=4';

export const CLAUDE_GITHUB_ID = '81847';
export const CLAUDE_LOGIN = 'claude';
export const CLAUDE_AVATAR = 'https://avatars.githubusercontent.com/u/81847?v=4';
export const CLAUDE_APP_GITHUB_ID = '209825114';
export const CLAUDE_APP_LOGIN = 'claude[bot]';
export const CLAUDE_APP_AVATAR = 'https://avatars.githubusercontent.com/in/1236702?v=4';

export const GITHUB_ACTIONS_BOT_ID = '41898282';
export const GITHUB_ACTIONS_BOT_LOGIN = 'github-actions[bot]';
export const GITHUB_ACTIONS_BOT_AVATAR = 'https://avatars.githubusercontent.com/in/29164?v=4';

// Requested by customer (Ahoy)
export const AHOY_INFRASTRUCTURE_BOT_ID = '247621083';
export const AHOY_INFRASTRUCTURE_BOT_LOGIN = 'ahoy-infrastructure[bot]';
export const AHOY_INFRASTRUCTURE_BOT_AVATAR =
  'https://avatars.githubusercontent.com/u/225631102?v=4';

// Google's Jules coding agent
export const JULES_GITHUB_ID = '161369871';
export const JULES_LOGIN = 'google-labs-jules[bot]';
export const JULES_AVATAR = 'https://avatars.githubusercontent.com/in/842251?v=4';

export const CURSOR_GITHUB_ID = '206951365';
export const CURSOR_LOGIN = 'cursor[bot]';
export const CURSOR_AVATAR = 'https://avatars.githubusercontent.com/in/1210556?v=4';

export const AMAZON_Q_GITHUB_ID = '208079219';
export const AMAZON_Q_LOGIN = 'amazon-q-developer[bot]';
export const AMAZON_Q_AVATAR = 'https://avatars.githubusercontent.com/in/1220912?v=4';

export const GEMINI_CODE_ASSIST_GITHUB_ID = '176961590';
export const GEMINI_CODE_ASSIST_LOGIN = 'gemini-code-assist[bot]';
export const GEMINI_CODE_ASSIST_AVATAR = 'https://avatars.githubusercontent.com/in/956858?v=4';

export const REPLIT_GITHUB_ID = '129699003';
export const REPLIT_LOGIN = 'replit[bot]';
export const REPLIT_AVATAR = 'https://avatars.githubusercontent.com/in/313035?v=4';

export const V0_GITHUB_ID = '216274133';
export const V0_LOGIN = 'v0[bot]';
export const V0_AVATAR = 'https://avatars.githubusercontent.com/u/215908095?v=4';

export const LOVABLE_GITHUB_ID = '193578302';
export const LOVABLE_LOGIN = 'lovable[bot]';
export const LOVABLE_AVATAR = 'https://avatars.githubusercontent.com/u/5621667?v=4';

export const CONTINUE_GITHUB_ID = '230936708';
export const CONTINUE_LOGIN = 'continue[bot]';
export const CONTINUE_AVATAR = 'https://avatars.githubusercontent.com/in/1916892?v=4';

export const CODERABBIT_GITHUB_ID = '136622811';
export const CODERABBIT_LOGIN = 'coderabbitai[bot]';
export const CODERABBIT_AVATAR = 'https://avatars.githubusercontent.com/in/347564?v=4';

export const CODE_MONSTER_GITHUB_ID = '258798722';
export const CODE_MONSTER_LOGIN = 'codemonsterapp[bot]';
export const CODE_MONSTER_AVATAR = 'https://avatars.githubusercontent.com/in/2778442?v=4';

// Add a shared type for coding agent bots
export type CodingAgentBot = {
  githubUserId: string;
  login: string;
  avatarUrl: string;
};

// Keep individual constants above for backwards-compatibility, but create a single
// authoritative list so new bots can be added in *one* place.
export const CODING_AGENT_BOTS = [
  {
    githubUserId: DEVIN_GITHUB_ID,
    login: DEVIN_LOGIN,
    avatarUrl: DEVIN_AVATAR,
  },
  {
    githubUserId: COPILOT_AGENT_ID,
    login: COPILOT_AGENT_LOGIN,
    avatarUrl: COPILOT_AGENT_AVATAR,
  },
  {
    githubUserId: CODEGEN_GITHUB_ID,
    login: CODEGEN_LOGIN,
    avatarUrl: CODEGEN_AVATAR,
  },
  {
    githubUserId: FACTORY_DROID_GITHUB_ID,
    login: FACTORY_DROID_LOGIN,
    avatarUrl: FACTORY_DROID_AVATAR,
  },
  {
    githubUserId: CLAUDE_GITHUB_ID,
    login: CLAUDE_LOGIN,
    avatarUrl: CLAUDE_AVATAR,
  },
  {
    githubUserId: CLAUDE_APP_GITHUB_ID,
    login: CLAUDE_APP_LOGIN,
    avatarUrl: CLAUDE_APP_AVATAR,
  },
  {
    githubUserId: GITHUB_ACTIONS_BOT_ID,
    login: GITHUB_ACTIONS_BOT_LOGIN,
    avatarUrl: GITHUB_ACTIONS_BOT_AVATAR,
  },
  {
    githubUserId: AHOY_INFRASTRUCTURE_BOT_ID,
    login: AHOY_INFRASTRUCTURE_BOT_LOGIN,
    avatarUrl: AHOY_INFRASTRUCTURE_BOT_AVATAR,
  },
  {
    githubUserId: JULES_GITHUB_ID,
    login: JULES_LOGIN,
    avatarUrl: JULES_AVATAR,
  },
  {
    githubUserId: CURSOR_GITHUB_ID,
    login: CURSOR_LOGIN,
    avatarUrl: CURSOR_AVATAR,
  },
  {
    githubUserId: AMAZON_Q_GITHUB_ID,
    login: AMAZON_Q_LOGIN,
    avatarUrl: AMAZON_Q_AVATAR,
  },
  {
    githubUserId: GEMINI_CODE_ASSIST_GITHUB_ID,
    login: GEMINI_CODE_ASSIST_LOGIN,
    avatarUrl: GEMINI_CODE_ASSIST_AVATAR,
  },
  {
    githubUserId: REPLIT_GITHUB_ID,
    login: REPLIT_LOGIN,
    avatarUrl: REPLIT_AVATAR,
  },
  {
    githubUserId: V0_GITHUB_ID,
    login: V0_LOGIN,
    avatarUrl: V0_AVATAR,
  },
  {
    githubUserId: LOVABLE_GITHUB_ID,
    login: LOVABLE_LOGIN,
    avatarUrl: LOVABLE_AVATAR,
  },
  {
    githubUserId: CONTINUE_GITHUB_ID,
    login: CONTINUE_LOGIN,
    avatarUrl: CONTINUE_AVATAR,
  },
  {
    githubUserId: CODERABBIT_GITHUB_ID,
    login: CODERABBIT_LOGIN,
    avatarUrl: CODERABBIT_AVATAR,
  },
  {
    githubUserId: CODE_MONSTER_GITHUB_ID,
    login: CODE_MONSTER_LOGIN,
    avatarUrl: CODE_MONSTER_AVATAR,
  },
] as const satisfies readonly CodingAgentBot[];

/**
 * Helper — case-insensitive check whether a login is a known coding agent.
 */
export function isCodingAgentLogin(
  login: string | undefined | null,
): login is CodingAgentBot['login'] {
  if (!login) {
    return false;
  }
  return CODING_AGENT_BOTS.some((bot) => bot.login.toLowerCase() === login.toLowerCase());
}

/**
 * Retrieve a coding agent bot definition by login (case insensitive).
 */
export function getCodingAgentByLogin(login: string): CodingAgentBot | undefined {
  return CODING_AGENT_BOTS.find((bot) => bot.login.toLowerCase() === login.toLowerCase());
}

/**
 * Retrieve a coding agent bot definition by GitHub user id.
 */
export function getCodingAgentById(id: string | number): CodingAgentBot | undefined {
  const idStr = id.toString();
  return CODING_AGENT_BOTS.find((bot) => bot.githubUserId === idStr);
}
